import { useEffect, useState, useCallback } from "react";
import { api } from "../../lib/api";

export default function AdminCheckinLogs() {
    const [logs, setLogs] = useState([]);
    const [leaders, setLeaders] = useState([]);

    const load = useCallback(async () => {
        const [a, b] = await Promise.all([
            api.get("/admin/checkin/logs?limit=200"),
            api.get("/admin/checkin/leaderboard"),
        ]);
        setLogs(a.data);
        setLeaders(b.data);
    }, []);
    useEffect(() => { load(); }, [load]);

    const tone = (s) => s === "ok" ? "text-green-400" : s === "already" ? "text-gold" : "text-red-400";

    return (
        <div data-testid="admin-checkin-logs">
            <div className="flex justify-between items-start mb-8 flex-wrap gap-4">
                <div>
                    <div className="text-gold text-[10px] tracking-[0.4em] uppercase font-bold mb-2">Audit Trail</div>
                    <h1 className="h-display text-4xl">Check-in Logs</h1>
                </div>
                <button onClick={load} data-testid="logs-refresh" className="btn-ghost-gold px-4 py-2 text-xs">Refresh</button>
            </div>

            <div className="grid lg:grid-cols-[1fr_2fr] gap-6">
                <div className="card-flat p-5">
                    <div className="text-gold text-[10px] tracking-[0.3em] uppercase font-bold mb-4">Staff Leaderboard</div>
                    {leaders.length === 0 ? (
                        <div className="text-ink text-sm">No scans yet.</div>
                    ) : (
                        <ol className="space-y-3" data-testid="leaderboard">
                            {leaders.map((s, i) => (
                                <li key={s.staff_email} className="flex items-center gap-3" data-testid={`leader-row-${i}`}>
                                    <div className="h-display text-2xl text-gold w-8">{i + 1}</div>
                                    <div className="flex-1">
                                        <div className="text-white text-sm">{s.staff_email}</div>
                                        <div className="text-ink text-[10px] tracking-widest uppercase">
                                            last scan {s.last_scan ? new Date(s.last_scan).toLocaleTimeString() : "—"}
                                        </div>
                                    </div>
                                    <div className="h-display text-3xl">{s.scans}</div>
                                </li>
                            ))}
                        </ol>
                    )}
                </div>

                <div className="card-flat overflow-x-auto">
                    <table className="w-full text-sm">
                        <thead className="bg-bg-soft border-b border-line">
                            <tr>
                                <th className="text-left p-3 text-[10px] uppercase tracking-widest text-ink">Time</th>
                                <th className="text-left p-3 text-[10px] uppercase tracking-widest text-ink">Staff</th>
                                <th className="text-left p-3 text-[10px] uppercase tracking-widest text-ink">Token</th>
                                <th className="text-left p-3 text-[10px] uppercase tracking-widest text-ink">Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {logs.map((l) => (
                                <tr key={l.id} className="border-t border-line" data-testid={`log-${l.id}`}>
                                    <td className="p-3 text-ink text-xs">{new Date(l.created_at).toLocaleString()}</td>
                                    <td className="p-3 text-xs">{l.staff_email}</td>
                                    <td className="p-3 font-mono text-[10px] text-ink">{l.qr_token.slice(0, 16)}…</td>
                                    <td className={`p-3 text-xs uppercase tracking-widest font-bold ${tone(l.status)}`}>{l.status}</td>
                                </tr>
                            ))}
                            {logs.length === 0 && <tr><td colSpan={4} className="p-12 text-center text-ink">No scans logged yet.</td></tr>}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}
